import { z } from '@betty/toolkit/api';

export const JackpotSchema = z.object({
  gameId: z.number(),
  startAmount: z.number(),
  endAmount: z.number(),
  stepPerSecond: z.number(),
});

export const JackpotsSchema = z.object({
  jackpots: z.array(JackpotSchema),
});
